import { Allow, Matches, MinLength } from 'class-validator';
import { IsMobileNumber } from '../../../util/validation';
import { Profile } from '../../response';

export class EditUserProfileModel {
    @Allow()
    public id: string;

    @Matches(/^[^\s].*[^\s]$/, { message: 'Cannot begin or end with a space' })
    @MinLength(3, {
        message: 'Must be at least $constraint1 characters long',
    })
    public firstname: string = '';

    @Matches(/^[^\s].*[^\s]$/, { message: 'Cannot begin or end with a space' })
    @MinLength(3, {
        message: 'Must be at least $constraint1 characters long',
    })
    public middleName: string = '';

    @Matches(/^[^\s].*[^\s]$/, { message: 'Cannot begin or end with a space' })
    @MinLength(3, {
        message: 'Must be at least $constraint1 characters long',
    })
    public lastName: string = '';

    @IsMobileNumber({ message: 'Invalid phone number format' })
    public phoneNumber: string = '';

    constructor(user: Profile) {
        this.id = user.id;
        this.firstname = user.firstName;
        this.middleName = user.middleName;
        this.lastName = user.lastName;
        this.phoneNumber = user.phoneNumber;
    }
}
